import React from 'react';
import { LazyLoadImage } from "react-lazy-load-image-component";
import { XMarkIcon } from '@heroicons/react/24/outline';

function ProductCard(props) {
  const togglePopupProduct = (productId) =>{
    [].forEach.bind(document.getElementsByClassName(`popup_product ${productId}`),function(itm){
      itm.style.display = "flex";
    })();
  }

  const closePopupProduct = (productId) =>{
      [].forEach.bind(document.getElementsByClassName(`popup_product ${productId}`),function(itm){
          itm.style.display = "none";
      })();
  }

  return (
    <div>
      <div className='bg-white w-80 h-64 sm:w-60 md:w-56 md:h-80 form1:w-72 rounded-lg flex flex-col overflow-hidden drop-shadow-md hover:scale-105'>
        
        <div className='bg-slate-600 md:-skew-y-6 w-full h-1/2 md:h-2/3 md:-mt-7'>
          <LazyLoadImage src={props.image} className='object-cover h-full w-full max-h-product-img' alt={props.title}>

          </LazyLoadImage>
        </div>

        <div className='md:-skew-y-6 w-full md:h-1 bg-white md:-mb-28 -mt-6 h-2 md:-mt-0'>

        </div>

        <div className='bg-primary-300 w-full h-96 md:-mt-8 md:-mb-14 flex flex-col items-center md:space-y-3 space-y-2'>
          <div className='relative w-full md:mt-32'>
            <div className='rounded-full bg-primary-100 md:w-10 md:h-10 text-center items-center text-white absolute -right-0 -top-5 cursor-pointer w-8 h-8 hover:bg-primary-200' onClick={() => {togglePopupProduct(props.id)}}>
              <div className='w-full h-full flex flex-col items-center justify-center'>
                <LazyLoadImage src='/images/information-icon.png' className='md:w-5 md:h-5 w-4 h-4 pointer-events-none' alt='information-button'>
                
                </LazyLoadImage>
              </div>
            </div>
          </div>

          <h2 className='text-primary-100 md:font-semibold md:text-lg text-base font-normal pt-2'>{props.title}</h2>
          
          <div className='md:font-light md:text-sm text-center md:text-justify text-xs font-extralight px-7 lg:px-5 md:px-3 overflow-y-hidden w-full h-16'>
            {props.description}
          </div>
          
          <div className='md:font-light md:text-base text-center font-extralight text-sm'>
            ₡ {props.price}
          </div>
        </div>
      </div>

      <div className={`hidden h-screen w-screen fixed backdrop-blur-sm mt-navbar-mobile bg-popup inset-0 z-50 items-center justify-center popup_product ${props.id} px-4 sm:px-10`}> 
        <div className='relative md:max-w-3xl max-w-md w-full flex flex-col justify-center items-center mx-10 sm:mx-5 h-auto bg-white rounded-2xl overflow-y-auto'>
          
          <button onClick={() => {closePopupProduct(props.id)}} className='absolute top-1 right-1 hover:text-primary-100 bg-white opacity-90 md:bg-transparent rounded-full'><XMarkIcon className='w-8 h-8 md:w-10 md:h-10'/></button>
          
          <div className='w-full flex flex-col md:flex-row h-1/2 md:h-screen md:max-h-popup-mobile overflow-y-auto'>
            <div className='w-full md:h-full h-1/3'>
              
              <LazyLoadImage id={"img"} src={props.image} alt={props.title} className={`object-cover w-full h-full max-h-52 md:max-h-max`}>

              </LazyLoadImage>
            </div>

            <div className='w-full flex justify-center md:mt-14 px-4 h-2/3 flex-col items-center space-y-4 md:space-y-12 pb-4 md:justify-start md:h-auto md:max-h-popup-mobile'>
              <div>
                <h2 className='text-primary-100 md:font-bold md:text-2xl text-xl font-normal mt-2'>{props.title}</h2>
              </div>
              <div className='md:font-light md:text-lg text-center text-base font-extralight px-2 overflow-y-auto w-full h-full max-h-40 md:h-40'>
                {props.description}
              </div>
              
              <div className='hidden h-10 md:block'>

              </div>

              <div className='md:font-light md:text-lg text-center font-extralight text-base'>
                ₡ {props.price}
              </div>
              <button onClick={() => {props.action(true)}}
                className='mt-4 w-36 h-10 md:h-12 text-sm sm:text-base bg-primary-100
              text-white rounded-full font-bold md:text-xl hover:bg-primary-200'>Consultar</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ProductCard;
